import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { FormGroup, FormControl, FormBuilder, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { _ } from 'underscore';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { ObservablesService } from "../observables.service"
@Component({
  selector: 'app-paid-invoice-view',
  templateUrl: './paid-invoice-view.component.html',
  styleUrls: ['./paid-invoice-view.component.scss'],
})
export class PaidInvoiceViewComponent implements OnInit {
  paidInvoices:any=[];
  total:any=0;
  selectedParty:any=null;
  selectedTag:any=null;

  user_id:any;
  loggedUserInfo:any=[]
  selectedRangeDates:any;

_selectedClient:any;
displayedColumns: string[] = ['invoice_date', 'business_name' ,'total_amount'];
paidInvoicesData:MatTableDataSource<any>;
@ViewChild(MatSort, {static: true}) sort: MatSort;
@Input() set selectedLastClient(selectedClient){

  this._selectedClient =  selectedClient;
}

@Input() set selectedClient(selectedClient){
  // console.log("selectedClient==",selectedClient)
  this._selectedClient =  selectedClient;
  // if(!_.isEmpty(this._selectedClient)){
  // // if(this._selectedClient !== undefined){
  //
  //   // if(this.selectedParty){
  //   //
  //   //     this.getDatewiseInvoices()
  //   // }else{
  //
  //     if(this.selectedRangeDates){
  //
  //       this.getAllInvoices();
  //     }
  //   // }
  // }else if(this._selectedClient === undefined){
  //
  //   if(this.selectedRangeDates){
  //
  //     this.getAllInvoices(true)
  //   }
  // }
}

@Input() set selectedData(selectedData){
  // console.log("party  date selected==",dateRangeSelected)
  if(selectedData === undefined){
  }else{
    this.selectedRangeDates = selectedData.selectedDates;
    this.selectedParty = (selectedData.selectedParty)?selectedData.selectedParty.id:null
    this.selectedTag = (selectedData.selectedTag)?selectedData.selectedTag.id:null
    if(this.selectedParty || this.selectedTag){

      if(this.selectedParty && this.selectedTag){
        this.getInvoices(false,true,true)
      }else if(this.selectedParty && !this.selectedTag){
        this.getInvoices(false,true,false)
      }else if(!this.selectedParty && this.selectedTag){
        this.getInvoices(false,false,true)
      }else{
        this.getInvoices(false)
      }

    }else if(!this.selectedParty || !this.selectedTag){
      if(!_.isEmpty(this._selectedClient)){
        this.getInvoices(true)
      }else{
        this.getInvoices(false)
      }
    }
  // if(selectedData === undefined){
  // }else{
  //   this.selectedRangeDates = selectedData.selectedDates;
  //   this.selectedParty = (selectedData.selectedParty)?selectedData.selectedParty.id:null;
  //   if(this.selectedParty){
  //     if(!_.isEmpty(this._selectedClient)){
  //     // if(this._selectedClient !== undefined){
  //       // console.log("in if")
  //       this.getDatewiseInvoices(true)
  //     }else if(this._selectedClient === undefined){
  //       this.getDatewiseInvoices(true,false)
  //     }else{
  //       // console.log("in else")
  //       this.getDatewiseInvoices()
  //     }
  //   }else{
  //     if(!_.isEmpty(this._selectedClient)){
  //     // if(this._selectedClient !== undefined){
  //
  //       this.getAllInvoices();
  //     }else{
  //       this.getAllInvoices(true);
  //     }
  //   }
  }
}

getInvoices(client_status=false,party_status=false,tag_status=false){
  this.api.getLoggedUserInfo().then((res:any)=>{
    if(res.data.length > 0){
      this.loggedUserInfo = res.data[0];
      let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
      let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');

      let conditions:any;
      let fields:any;
      let joins:any;
      if(client_status){
        joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
        conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id,"I.user_id":this._selectedClient.id};
      }else{

        if(party_status && tag_status){
          joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.invoice_id = I.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
          conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.party_id":this.selectedParty,"I.business_id":this.loggedUserInfo.business_id, "ST.tag_id":this.selectedTag};
        }else if(party_status && !tag_status){
          joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
          conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.party_id":this.selectedParty,"I.business_id":this.loggedUserInfo.business_id};
        }else if(!party_status && tag_status){
          joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.invoice_id = I.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
          conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id, "ST.tag_id":this.selectedTag};

        }else if(!party_status && !tag_status){
          joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
          conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id};
        }
      }


      this.api.send("findDb",{
        fields:["I.*, P.*,I.id as id,I.party_name as busi_name, DATEDIFF(CURDATE(),STR_TO_DATE(invoice_date, '%Y-%m-%d')) AS days"],
        table:"master_invoices as I",
        joins:joins,
        conditions:[conditions],
        order:"I.id DESC"
      }).then((res:any)=>{
        this.paidInvoices=res.data;
        this.paidInvoicesData = new MatTableDataSource(this.paidInvoices);
        this.paidInvoicesData.sort = this.sort;
      })
    }else{
      this.api.logOut()
    }
  })
}

  constructor(private datePipe:DatePipe, private formBuilder: FormBuilder, private api:ApiService, private router: Router, private observables:ObservablesService) { }

  ngOnInit() {
    this.api.getLoggedUserInfo().then((res:any)=>{
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
      }else{
        this.api.logOut()
      }
    })
  }

  getAdminInfo(id){
    return new Promise((resolve,reject)=>{
       this.api.send("findDb",{
         table:"users",
         conditions:[{id:id, role:'admin'}]
       }).then((userRes:any)=>{
         if(userRes.data.length > 0){

           resolve({status:true,userData:userRes.data[0]})
         }else{
           resolve({status:false})
         }
       })

    })
  }

  totalAmount(){
    return this.paidInvoices.reduce( ( accumulator, currentValue ) => {
      return accumulator + parseFloat(currentValue.total_amount);
    }, 0);
  }


  getAllInvoices(allStatus = false){
    let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
    let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');
    let conditions:any;
    if(allStatus){
      conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id};
    }else{
      conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id,"I.user_id":this._selectedClient.id};
    }

    this.api.send("findDb",{
      fields:["I.*, P.*,I.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(invoice_date, '%Y-%m-%d')) AS days"],
      table:"invoices as I",
      joins:[{
        type:"left",
        table:"parties as P",
        conditions:["P.id = I.party_id"]
      }],
      conditions:[conditions],
      order:"I.id DESC"
    }).then((res:any)=>{
      this.paidInvoices=res.data;
      this.paidInvoicesData = new MatTableDataSource(this.paidInvoices);
      this.paidInvoicesData.sort = this.sort;
    })
  }

  getDatewiseInvoices(specific_status=false,allStatus = false){
    // console.log("selected date ranges=",this.selectedRangeDates)
    let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
    let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');
    let conditions:any;
    if(specific_status && !allStatus){
      conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0, "I.party_id":this.selectedParty, "I.business_id":this.loggedUserInfo.business_id};
    }else if(specific_status && allStatus){

      conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0, "I.business_id":this.loggedUserInfo.business_id};
    }else{
      conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0, "I.party_id":this.selectedParty, "I.business_id":this.loggedUserInfo.business_id,"I.user_id":this._selectedClient.id};
    }

    this.api.send("findDb",{
      fields:["I.*, P.*,I.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(invoice_date, '%Y-%m-%d')) AS days"],
      table:"invoices as I",
      joins:[{
        type:"left",
        table:"parties as P",
        conditions:["P.id = I.party_id"]
      }],
      conditions:[conditions],
      order:"I.id DESC"
    }).then((res:any)=>{
      this.paidInvoices=res.data;
      this.paidInvoicesData = new MatTableDataSource(this.paidInvoices);
      this.paidInvoicesData.sort = this.sort;
    })
  }



  gotoUnpaid(paidData){
    this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/unpaid-invoice')],{ state: { data: paidData } });
    // this.observables.setPage({page:"unpaid-invoice",data:paidData})
  }

  deleteInvoice(paidInvoice,index){
    if(confirm("Are you sure to Delete Invoice No: "+paidInvoice.invoice_number +"?")){

      this.api.send("updateDb",{
        table:"master_invoices",
        data:{
          delete_status:1
        },
        conditions:[{id:paidInvoice.id}]
      }).then((res:any)=>{
        if(res.data.affectedRows){
          this.observables.showToastMessage({type:0,message:"Invoice Deleted Successfully."})
          this.paidInvoices.splice(index, 1)
          this.paidInvoicesData = new MatTableDataSource(this.paidInvoices);
          this.paidInvoicesData.sort = this.sort;
        }else{

          this.observables.showToastMessage({type:1,message:"Can\'t Delete Invoice. Try again.."})
        }
      })
    }
  }

  // refreshInvoiceList(){
  //   if(!this.selectedParty){
  //
  //     this.getAllInvoices()
  //   }else{
  //
  //     this.getDatewiseInvoices()
  //   }
  // }

  showInvoice(invoiceData){
    // console.log("invoice data==",invoiceData)
    // this.observables.invoiceViewStatus.next({id:invoiceData.id,invoiceData:invoiceData})
    this.observables.invoiceViewStatus.next({id:invoiceData.id,invoiceData:invoiceData})
  }
}
